import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAllSpecifications } from "../redux/modelsComparatorSlice";
import CardEmpty from "./CardEmpty";
import useGetTranslations from "../../../../../dealers/assets/js/dealers_map/hooks/useGetTranslations";

export default function CardDetail({ id, quotation, testDrive, serieSelected }) {
    const [translations] = useGetTranslations(
        // locale,
        "/api/vehicles/get_translations/"
    );

    const dispatch = useDispatch();

    const [specifications, setSpecifications] = useState([]); // lista de features de la version seleccionada
    let parents = [];

    const versionSelected =
        id == "firstItem"
            ? useSelector((state) => state.modelsComparator.firstItem)
            : id == "secondItem"
            ? useSelector((state) => state.modelsComparator.secondItem)
            : id == "thirdItem"
            ? useSelector((state) => state.modelsComparator.thirdItem)
            : null;

    const diffSpecifications =
        id == "firstItem"
            ? useSelector((state) => state.modelsComparator.firstSpecifications)
            : id == "secondItem"
            ? useSelector((state) => state.modelsComparator.secondSpecifications)
            : id == "thirdItem"
            ? useSelector((state) => state.modelsComparator.thirdSpecifications)
            : null;

    const differences = useSelector(
        (state) => state.modelsComparator.differences
    );
    const features = useSelector((state) => state.modelsComparator.features);

    useEffect(() => {
        setSpecifications(versionSelected.specifications);
        dispatch(setAllSpecifications());
    }, [versionSelected]);

    specifications?.map((e) => {
        parents.push(e.parent_name);
        parents = [...new Set(parents)];
    });

    const elements = parents?.map((p, i) => {
        if (features.includes("all")) {
            return (
                <div className="comparator-card-detail_detail" key={i}>
                    <p className="detail-title">
                        <strong>{p}</strong>
                    </p>
                    <ul>
                        {specifications?.map((e, i) => {
                            return e.parent_name === p ? (
                                <li className="--text-l" key={i}>
                                    <strong>{e.specification_name}</strong>{" "}
                                    {e.value}
                                </li>
                            ) : null;
                        })}
                    </ul>
                </div>
            );
        }
        if (features.includes(p)) {
            return (
                <div className="comparator-card-detail_detail" key={i}>
                    <p className="detail-title">
                        <strong>{p}</strong>
                    </p>
                    <ul>
                        {specifications?.map((e, i) => {
                            return e.parent_name === p ? (
                                <li className="--text-l" key={i}>
                                    <strong>{e.specification_name}</strong>{" "}
                                    {e.value}
                                </li>
                            ) : null;
                        })}
                    </ul>
                </div>
            );
        }
    });

    const elementsDiff = parents?.map((p, i) => {
        return (
            <div className="comparator-card-detail_detail" key={i}>
                <p className="detail-title">
                    <strong>{p}</strong>
                </p>
                <ul>
                    {diffSpecifications?.map((e, i) => {
                        return e.parent_name === p ? (
                            <li className="--text-l" key={i}>
                                <strong>{e.specification_name}</strong>{" "}
                                {e.value}
                            </li>
                        ) : null;
                    })}
                </ul>
            </div>
        );
    });

    const formatPrice = (price) => {
        return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    const getPriceAndCurrencyInsidePTag = () => {
        if(versionSelected.price > 0){
            const formatted = formatPrice(versionSelected.price)


            if(versionSelected.currency.toUpperCase() == "USD"){
                return (
                    <p className="--text-s">
                        ${formatted}
                    </p>
                )
            } else if (versionSelected.currency.toUpperCase() == "CLP"){
                return (
                    <p className="--text-s">
                        CLP {formatted} 
                    </p>
                )
            }
        }
    }

    return versionSelected.id ? (
        <div className="comparator-card-detail">
            <p className="title">{versionSelected.name}</p>
            { getPriceAndCurrencyInsidePTag() }
            {
                versionSelected.green_tax &&
                <span className="green-tax">+ Impuesto Verde ${formatPrice(versionSelected.green_tax)}</span>
            }
            
            <img src={versionSelected.image.url} alt="" />
            {versionSelected.data_sheet ? (
                <a
                    className="text-link primary-link-black --link-s"
                    href={versionSelected.data_sheet}
                    target="_blank"
                >
                    {translations.text14}
                </a>
            ) : null}

            {!differences ? elements : elementsDiff}

            <a className="btn-large btn-outline-black" href={quotation + "?serie_id="+ serieSelected.id +"&version_id=" + versionSelected.id} target="_blank">
                {translations.text15}
            </a>
            <a
                className="text-link primary-link-black --link-m"
                href={testDrive + "?serie_id="+ serieSelected.id +"&version_id=" + versionSelected.id}
                target="_blank"
            >
                {translations.text16}
            </a>
        </div>
    ) : (
        <CardEmpty error={true} />
    );
}
